import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Importa il file App.jsx

import './index.css'; // Se hai uno stile globale (opzionale)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
